import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import dayjs from "dayjs";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import KPTimePicker from "../../../components/KPTimePicker";

import { uploadMultiFile } from "../../../reducer/file/action";
import { updateExhibition, checkDuplicateExhibition } from "../../../reducer/exhibition/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";
import DuplicateCheckModal from "../../../components/Exhibition/DuplicateCheckModal";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";
import {
  getTimeResearchInformation,
  getTimeResearchInformationById,
} from "../../../reducer/timeResearchInformation/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function ExhibitionUpdateModal(props) {
  const { updating, setUpdating } = props;
  const [disabled, setDisabled] = useState(true);

  const [values, setValues] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [fileManagerKey, setFileManagerKey] = useState(0);
  const currentYear = getCurrentSchoolYear();
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(null);

  //   const yearList = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028];
  const profileListFromProps = props.profileList;
  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const yearList = [];
  // console.log(props.timeResearchInformationList);
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  useEffect(() => {
    if (updating) {
      resetValues();
      if (updating._fromDuplicate) {
        setDisabled(false);
      }
    }
  }, [updating]);

  useEffect(() => {
    if (updating && updating._fromDuplicate && props.profile?.id) {
      const hasCurrentUser = profileList.some((member) => member.profileId === props.profile.id);

      if (!hasCurrentUser) {
        setProfileList([
          ...profileList,
          {
            profileId: props.profile.id,
            roleInExhibition: "member",
            isInternal: true,
            externalName: "",
            timeAmount: null,
          },
        ]);
      }
    }
  }, [updating, props.profile?.id]);

  useEffect(() => {
    if (values?.profileIdForKpi >= 0) props.getTimeResearchInformation(0, timeResearchYear);
  }, [values?.profileIdForKpi, timeResearchYear]);

  useEffect(() => {
    const timeResearchDetailId = parseInt(values?.timeResearchDetailCode?.split("-").slice(0, 1).shift());
    if (timeResearchDetailId) props.getTimeResearchInformationById(timeResearchDetailId);
  }, [values?.timeResearchDetailCode]);

  //   useEffect(() => {
  //     if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  //   }, [values?.profileIdForKpi]);

  useEffect(() => {
    if (props.employmentContractDetail)
      setValues({
        ...values,
        profileIdForKpi: props.employmentContractDetail?.profile?.id,
      });
  }, [props.employmentContractDetail]);

  useEffect(() => {
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type === "exhibition");
      setTimeResearchDetailList(list || []);
    }
  }, [timeResearchYear, props.timeResearchInformationList]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  };

  const resetValues = () => {
    setValues({
      ...updating,
      time: updating.time ? dayjs(updating.time).format("DD/MM/YYYY") : "",
    });
    setProfileList([...updating.exhibitionProfile] || []);
    setFileUrls(updating.fileUrl?.split("||").filter(Boolean) || []);
    setNewFiles([]);
    setFileManagerKey((prev) => prev + 1);

    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2025;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInExhibition: "member",
      isInternal: true,
      externalName: "",
      timeAmount: null,
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleClose = () => {
    if (!disabled) {
      resetValues();
      setDisabled(true);
    } else {
      setUpdating(null);
      setDisabled(true);
      setFileUrls([]);
      setNewFiles([]);
      setFileManagerKey((prev) => prev + 1);
    }
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);
  };

  const updateExhibitionItem = async (id, payload) => {
    let result = await props.updateExhibition(id, {
      ...payload,
      time: dateFormat(payload?.time),
      exhibitionProfile: profileList,
    });
    return result;
  };

  const checkForDuplicates = async (title, currentId) => {
    if (!title || title.trim() === "") {
      return { hasDuplicates: false, data: [] };
    }

    const result = await props.checkDuplicateExhibition({
      publicationType: "exhibitions",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      const filteredDuplicates = result.data.filter((item) => item.exhibition?.id !== currentId);

      if (filteredDuplicates.length > 0) {
        return { hasDuplicates: true, data: filteredDuplicates };
      }
    }

    return { hasDuplicates: false, data: [] };
  };

  const handleSelectDuplicate = (item) => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(null);

    const exhibitionToEdit = {
      ...item.exhibition,
      exhibitionProfile: item.exhibitionProfile || [],
      _fromDuplicate: true,
    };

    setUpdating(exhibitionToEdit);
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);

    if (pendingSubmit) {
      proceedWithSubmit(pendingSubmit);
      setPendingSubmit(null);
    }
  };

  const proceedWithSubmit = async (submitData) => {
    let finalFileUrl = fileUrls.join("||");
    if (newFiles.length > 0) {
      const uploadResult = await props.uploadMultiFile(submitData.id, newFiles, "exhibition");
      if (uploadResult.success) finalFileUrl = [...fileUrls, ...uploadResult.data].join("||");
    }
    updateExhibitionItem(submitData.id, { ...submitData, fileUrl: finalFileUrl }).then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });

    setUpdating(null);
    setValues(null);
    setHelperText(false);
  };

  const handleSubmit = async () => {
    // Check required fields
    if (!values?.exhibitionName || !values?.artworkName || !values?.organizer || !values?.numOfAuthors) {
      setHelperText(true);
      return;
    }

    // Validate profileList for external members
    const hasEmptyExternalName = profileList.some((e) => !e.isInternal && e.externalName === "");
    if (hasEmptyExternalName) {
      setHelperText(true);
      return;
    }

    // Validate purposeId = 1 requires profileIdForKpi
    if (values?.purposeId === 1 && !values?.profileIdForKpi) {
      setHelperText(true);
      return;
    }

    // Validate purposeId = 5 requires timeResearchDetailCode
    if (values?.purposeId === 5 && !values?.timeResearchDetailCode) {
      setHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    if (disabled) {
      setDisabled(false);
    } else {
      // const duplicateCheck = await checkForDuplicates(values?.exhibitionName, values?.id);

      const submitData = {
        id: values.id,
        ...values,
      };

      // if (duplicateCheck.hasDuplicates) {
      //   setDuplicateList(duplicateCheck.data);
      //   setDuplicateModalOpen(true);
      //   setPendingSubmit(submitData);
      //   return;
      // }

      proceedWithSubmit(submitData);
    }
  };

  const handleOpenUploadModal = () => {};
  const handleCloseUploadModal = () => {};
  const handleOpenPreviewModal = () => {};
  const handleClosePreviewModal = () => {};

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Phản hồi về việc khai báo thông tin Triển lãm",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "exhibition",
      },
    });
  };

  return (
    <Dialog fullWidth keepMounted maxWidth="lg" open={updating !== null} onClose={handleClose} disableBackdropClick>
      <DialogTitle>Chi tiết triển lãm</DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div style={{ flex: "1 1 auto", minWidth: 0, paddingRight: 16 }}>
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tên triển lãm"
                variant="outlined"
                value={values?.exhibitionName?.toString() || ""}
                required
                disabled={disabled}
                error={helperText && !values?.exhibitionName}
                helperText={helperText && !values?.exhibitionName ? "Vui lòng nhập tên triển lãm" : ""}
                onChange={(event) => handleChangeForm("exhibitionName", event.target.value)}
              />
            </Grid>
            <Grid item xs={10}>
              <TextField
                fullWidth
                size="small"
                label="Tên tác phẩm triển lãm"
                variant="outlined"
                value={values?.artworkName?.toString() || ""}
                required
                disabled={disabled}
                error={helperText && !values?.artworkName}
                helperText={helperText && !values?.artworkName ? "Vui lòng nhập tên tác phẩm triển lãm" : ""}
                onChange={(event) => handleChangeForm("artworkName", event.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã CTKH"
                value={values?.hemisCode || ""}
                disabled={disabled}
                onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                size="small"
                disabled={disabled}
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            <Grid item xs={6}>
              <KPTimePicker
                fullWidth
                label="Thời gian"
                disabled={disabled}
                value={values?.time || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("time", newValue)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Địa điểm"
                value={values?.location || ""}
                disabled={disabled}
                onChange={(event) => handleChangeForm("location", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Đơn vị tổ chức"
                value={values?.organizer || ""}
                required
                disabled={disabled}
                error={helperText && !values?.organizer}
                helperText={helperText && !values?.organizer ? "Vui lòng nhập đơn vị tổ chức" : ""}
                onChange={(event) => handleChangeForm("organizer", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng tác giả"
                value={values?.numOfAuthors || ""}
                required
                disabled={disabled}
                error={helperText && !values?.numOfAuthors}
                helperText={helperText && !values?.numOfAuthors ? "Vui lòng nhập số lượng tác giả" : ""}
                onChange={(event) => handleChangeForm("numOfAuthors", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small" disabled={disabled}>
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? 3}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes
                    .filter((e) => e.name !== "bonusCalculated")
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.description}
                      </option>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            {values?.purposeId === 5 && (
              <>
                {/* <Grid item xs={3}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  value={timeResearchYear}
                  SelectProps={{ native: true }}
                  label="Năm học tính giờ nghiên cứu"
                  variant="outlined"
                  disabled={disabled}
                  onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                >
                  {yearList.map((e) => (
                    <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                      {e} - {e + 1}
                    </option>
                  ))}
                </TextField>
              </Grid> */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Cấp triển lãm"
                    variant="outlined"
                    disabled={disabled}
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    error={!values?.timeResearchDetailCode}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description} - ${e.value}(h)`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null} disabled>
                        Chưa có dữ liệu
                      </MenuItem>
                    )}
                  </TextField>
                  {!values?.timeResearchDetailCode && <FormHelperText error>Phải chọn cấp triển lãm!</FormHelperText>}
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                disabled={disabled}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values?.isOvertimeCountable || false}
                    disabled={disabled || props.role !== "sudo-admin"}
                    onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                    color="primary"
                  />
                }
                label="Tính giờ ngoài quy chế"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số giờ ngoài quy chế"
                variant="outlined"
                value={values?.overtimeHours ?? ""}
                disabled={disabled || props.role !== "sudo-admin" || !values?.isOvertimeCountable}
                onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                inputProps={{
                  min: 0,
                  step: 0.1,
                }}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                          disabled={disabled}
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 ? 5 : 4}>
                      <Autocomplete
                        disableClearable
                        disabled={disabled}
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={profileListFromProps?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 ? 5 : 4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        disabled={disabled}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId !== 1 ? 5 : 3}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInExhibition-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="roleInExhibition-label"
                        value={e.roleInExhibition}
                        onChange={(event) => handleChangeProfileList(index, "roleInExhibition", event.target.value)}
                      >
                        <option value="main">Tác giả</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null || disabled}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      disabled={disabled}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            {!disabled && (
              <Grid item xs={12}>
                <Button fullWidth variant="outlined" onClick={handleInsert}>
                  Thêm thành viên
                </Button>
              </Grid>
            )}
          </Grid>
          <div
            style={{
              flexDirection: "column",
              display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
            }}
          >
            <EmploymentContractTable
              contract={detail}
              contractList={contractList}
              kpiIdForKpi={values?.kpiIdForKpi}
              contractIdForKpi={values?.contractIdForKpi}
              setDetail={setDetail}
              values={values}
              setValues={setValues}
              handleChangeForm={handleChangeForm}
            />
            <EmploymentContractDetailTable kpi={detail} />
          </div>
        </div>
        <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
            File minh chứng
          </Typography>
          <MultiFileManager
            fileUrls={fileUrls}
            setFileUrls={setFileUrls}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={disabled}
            key={fileManagerKey}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div style={{ float: "right" }}>
            {props.adminTab && (
              <Button variant="outlined" onClick={handleSendFeedback} style={{ marginRight: 4 }}>
                Gửi feedback
              </Button>
            )}
            {disabled ? (
              <>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => setUpdating(null)}
                  style={{ marginRight: 4 }}
                >
                  Đóng
                </Button>
                {(props.role === "sudo-admin" || !updating?.locked) && (
                  <Button variant="contained" color="primary" onClick={() => setDisabled(false)}>
                    Chỉnh sửa
                  </Button>
                )}
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setDisabled(true);
                    resetValues();
                  }}
                  style={{ marginRight: 4 }}
                >
                  Huỷ
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                  Lưu
                </Button>
              </>
            )}
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        handleClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        handleSelect={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  isFetchingEmploymentContract: select(state, "employmentContractReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateExhibition: (id, payload) => dispatch(updateExhibition(id, payload)),
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
  getTimeResearchInformation: (departmentId, year) => dispatch(getTimeResearchInformation(departmentId, year)),
  getTimeResearchInformationById: (id) => dispatch(getTimeResearchInformationById(id)),
  checkDuplicateExhibition: (payload) => dispatch(checkDuplicateExhibition(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ExhibitionUpdateModal));

